import { FormControlBase } from './form-control-base';

export class AutoCompleteControl extends FormControlBase<string> {
    public controlType = 'autocomplete';
    public placeHolder: string = '';
    public options = new Array<{ key: string, value: string }>(); 
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/auto-complete-control.ts